import colors from './styles/colors'
import { isProduction } from 'variables/environment'
import { BrandConfigType } from 'types'
import { getBrandDefaultFeatures } from 'brands'

const brand: BrandConfigType = {
  liffID: {
    home: isProduction ? '1660658666-dNvo8rvw' : '1660658720-nL5N7Q3E',
    lineID: isProduction ? '@fattchicken' : '@186ydslr',
  },
  id: isProduction ? 101 : 215,
  title: 'FATT CHICKEN',
  label: 'FATT CHICKEN',
  slug: 'fattchicken',
  slogan: '',
  favIcon: `${process.env.PUBLIC_URL}/assets/fav-indydish.png`,
  brandSelectImg: '',
  theme: {
    ui: 'generic',
    colors,
  },
  ga4: {
    hatoStoreKey: isProduction ? 'G-RCBZ7BXHHZ' : '',
    dineInKey: isProduction ? 'G-XBGDMG62PC' : '',
  },
  omisePublicKey: isProduction ? 'pkey_5wmyme2bvgm21lppihh' : 'pkey_test_54yhq808rsaoya3zpmr',
  companyName: 'FATT CHICKEN',
  contactNumber: '(087) 717-2408',
  contactPolicy: '(087) 717-2408', // Email or Phone Number
  features: getBrandDefaultFeatures(),
}

export default brand
